import { Flex, Text } from '@mantine/core';
import { MyIcon } from '@web/common-ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../../../../../route/Routes';
import { observer } from 'mobx-react';
import withStoreProvider from '../../../../../../util/withStoreProvider';
import {
  useWonRafflesStore,
  WonRafflesStore,
  WonRafflesStoreProvider,
} from './stores/WonRafflesStore';
import {
  CONTENTFUL_SWISS_GERMAN_KEY,
  CONTENTFUL_ENGLISH_KEY,
} from '@web/common';
import { Language } from '@prisma/client';
import { inAppNavigation } from '../../../../../../hooks';

export const WonRaffleBannerContent = observer(() => {
  const store = useWonRafflesStore();
  const { t, i18n } = useTranslation('homescreen');
  const navigate = useNavigate();

  useEffect(() => {
    store.loadUncollectedRaffles();

    return () => {
      store.resetStore();
    };
  }, [store]);

  const mostRecentRaffle = store.mostRecentRaffle;

  if (!mostRecentRaffle) {
    return null;
  }

  const raffleId = mostRecentRaffle.sys.id;

  const translationKey =
    i18n.language === Language.de
      ? CONTENTFUL_SWISS_GERMAN_KEY
      : CONTENTFUL_ENGLISH_KEY;

  return (
    <Flex
      style={{
        border: '3px #1570CB solid',
        borderRadius: 8,
        padding: 24,
        cursor: 'pointer',
        backgroundColor: '#1570CB0D',
      }}
      align="center"
      gap="25px"
      onClick={() =>
        navigate(
          `${Routes.Study}/${Routes.Raffles}/${raffleId}`,
          inAppNavigation,
        )
      }
    >
      <div style={{ flex: 1 }}>
        <Text fw="600" size="16px" lh="24px">
          {t('WonRaffleBanner.Title')}
        </Text>
        <Text size="14px" lh="20px">
          {t('WonRaffleBanner.Description', {
            raffleTitle: mostRecentRaffle.fields.title[translationKey],
          })}
        </Text>
      </div>
      <MyIcon
        name="chevron_right"
        style={{ width: '24px', minWidth: '24px', fill: '#1570CB' }}
      />
    </Flex>
  );
});

export const WonRaffleBanner = withStoreProvider(
  new WonRafflesStore(),
  WonRafflesStoreProvider,
)(WonRaffleBannerContent);
